import EventBus from "@packages/event-bus";
import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/mac/",

        async list() {
            const url = this.url();

            return await Vue.http.get(url);
        },

        async listByMac(mac) {
            const url = this.url(`${mac}`);

            return await Vue.http.get(url);
        },       

        async create(data) {
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http
                .post(this.url(), data)
                .catch(error => {
                    EventBus.$emit("CANCEL_SPINNER");
                    throw error;
                });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async update(data) {
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http
                .put(this.url(), data)
                .catch(error => {
                    EventBus.$emit("CANCEL_SPINNER");
                    throw error;
                });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async remove(mac) {
            const url = this.url(`${mac}`);
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http.delete(url).catch(error => {
                EventBus.$emit("CANCEL_SPINNER");
                throw error;
            });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async uploadMacAddresses({ data }) {
            const url = this.url("upload");
           
            return Vue.http.post(url, data, 
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
        },
    },
    base
);
